import type {
  HostedAgentSource,
  HostedAgentSourceContent,
  HostedAgentSourceList,
} from "@/api/client/hosted-agents-sources"

import { api } from "@/lib/api-client"

const path = (agentId: string, sourceId?: string) =>
  `/admin/hosted-agents/${encodeURIComponent(agentId)}/sources${sourceId ? `/${encodeURIComponent(sourceId)}` : ""}`

export async function listAdminAgentSources(agentId: string): Promise<HostedAgentSourceList> {
  const response = await api.get(path(agentId))
  return response.data || response
}

export async function saveAdminAgentSource(
  agentId: string,
  input: {
    file?: File
    title: string
    usage_context: string
    source?: HostedAgentSource
    requestKey: string
  }
): Promise<HostedAgentSource> {
  let response
  if (input.file) {
    const body = new FormData()
    body.append("file", input.file)
    body.append("title", input.title)
    body.append("usage_context", input.usage_context)
    if (input.source) body.append("version", String(input.source.version))
    response = await api.request({
      url: path(agentId, input.source?.id),
      method: input.source ? "PUT" : "POST",
      data: body,
      headers: { "Idempotency-Key": input.requestKey },
    })
  } else {
    if (!input.source) throw new Error("A source file is required")
    response = await api.patch(path(agentId, input.source.id), {
      version: input.source.version,
      title: input.title,
      usage_context: input.usage_context,
    })
  }
  return (response.data || response).source
}

export async function revokeAdminAgentSource(
  agentId: string,
  source: HostedAgentSource
): Promise<void> {
  await api.delete(`${path(agentId, source.id)}?version=${source.version}`)
}

export async function readAdminAgentSource(
  agentId: string,
  source: HostedAgentSource,
  offset = 0
): Promise<HostedAgentSourceContent> {
  const response = await api.get(
    `${path(agentId, source.id)}/content?version=${source.version}&offset=${offset}`
  )
  return response.data || response
}
